import { Button, CircularProgress, Dialog, Grid, Grow, Icon, makeStyles } from '@material-ui/core'
import { red } from '@material-ui/core/colors';
import React from 'react'
import DisplayText from '../components/Texts/DisplayText';

const Transition = React.forwardRef(function Transition(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});

const useStyles = makeStyles(theme => ({
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5)
    },
    root:{
        paddingTop:32,
        paddingBottom:0
    },
    icon:{
        color:'white',
        background:red[700],
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    message:{
        paddingTop:16,
        paddingBottom:16,
        maxWidth:300
    }
}))

const ErrorModal = (props) => {

    const classes = useStyles()
    const {open, message, onClose} = props

    return(
        <Dialog open={open} maxWidth='xs' fullWidth classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition}>
            <div className={classes.root}>
                <Grid container direction='column' justify='center' alignItems='center' spacing={0}>
                    <Grid item>
                        <div className={classes.iconContainer}>
                            <Icon className={classes.icon}>close</Icon>
                        </div>
                    </Grid>
                    <Grid item>
                        <DisplayText variant='h6' style={{paddingTop:8}}>Opps...</DisplayText>
                    </Grid>
                    <Grid item>
                        <DisplayText variant='h6'>hubo un error</DisplayText>
                    </Grid>
                    <Grid item>
                        <div className={classes.message}>
                            <DisplayText color='bluegrey' align='center'>{message}</DisplayText>
                        </div>
                    </Grid>
                    <Grid item>
                        <Button size='large' onClick={onClose}>Continuar</Button>
                    </Grid>
                </Grid>
            </div>
        </Dialog>
    )
}

export default ErrorModal
